const getVisibilityStatus = (rootState) => rootState.ui.contextMenu.menu.visibility;

export default getVisibilityStatus;
